import './Layout.css';
export default {
    "wrapper": "Layout_wrapper__tugrv",
    "headWrapper": "Layout_headWrapper__tugrv",
    "title": "Layout_title__tugrv",
    "viewAll": "Layout_viewAll__tugrv",
    "itemList": "Layout_itemList__tugrv",
    "titleSizeLarge": "Layout_titleSizeLarge__tugrv",
    "rightArrow": "Layout_rightArrow__tugrv",
    "leftArrow": "Layout_leftArrow__tugrv"
};
